import _ from 'underscore';
import searchBoxTemplate from './template/search-box.pug';

export function renderSearchBox(searchBox) {
  const options = _.defaults({}, searchBox, {
    classes: [],
    id: _.uniqueId('search-box-'),
    placeholder: '',
    buttonLabel: 'Search',
    onChange: null,
    value: '',
    maxLength: null,
  });
  const html = searchBoxTemplate(options);
  const events = {};
  const { id, onChange } = options;
  const selector = `#${id}.search-box`;
  const selInput = `${selector} > input`;
  const selButton = `${selector} > button`;

  function onUserInput(e) {
    if (!e.keyCode || e.keyCode === 13) {
      const value = this.$(selInput).val();

      this.update({
        id: options.id,
        value,
      });

      if (_.isFunction(onChange)) {
        onChange(value);
      }
    }
  }

  events[`keyup ${selInput}`] = onUserInput;
  events[`click ${selButton}`] = onUserInput;

  return { html, events };
}

